import {
	FieldValues,
	FieldPath,
	useController,
	UseControllerProps,
} from 'react-hook-form';
import {
	Box,
	Checkbox,
	CheckboxProps,
	FormControlLabel,
	FormHelperText,
	SxProps,
} from '@mui/material';

interface SingleCheckboxProps {
	label: string;
	sx?: SxProps;
	handleChange?: any;
}

export default function SingleCheckbox<
	TFieldValues extends FieldValues = FieldValues,
	TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
	label,
	sx,
	handleChange,
	...props
}: SingleCheckboxProps &
	UseControllerProps<TFieldValues, TName> &
	CheckboxProps) {
	const { field, fieldState } = useController(props);
	const errorMessage = fieldState.error?.message;
	return (
		<Box>
			<FormControlLabel
				sx={sx}
				key={field.value}
				control={
					<Checkbox
						{...field}
						checked={field.value}
						onChange={(e) => {
							field.onChange(!field.value);
							handleChange && handleChange(!field.value);
						}}
					/>
				}
				label={label}
			/>
			<FormHelperText sx={{ color: 'red' }}>{errorMessage}</FormHelperText>
		</Box>
	);
}
